const customergroups = {
	title: "Customer Groups",
	new_customergroup: "New Customer Group",
	edit_customergroup: "Edit Customer Group: {name}",
	view_customergroup: "View Customer Group: {name}",
	list_title: "List of Customer Groups",
	list_subtitle: "Manage Customer Groups",
	create_title: "Create New Customer Group",
	update_title: "Update Customer Group",
	id: "ID",
	name: "Name",
	status: "Status",
	created_by: "Created By",
};
export default customergroups;